<template>
  <div class="top-brand">
    <section class="top-brand__list">
    
        <v-scroll-animation>
            <div class="top-brand__item--left top-brand__item--kagayaki">
                <div class="top-brand__wrap">
                    <img class="top-brand__img" src="/choice/img/top/kagayaki-img.jpg" alt="">
                    <div class="top-brand__body">
                        <h3 class="top-brand__title">かがやき<small class="top-brand__title-en">kagayaki</small></h3>
                        <div class="top-brand__description">
                            <p>かがやきシリーズでは、自由に組み合わせてオリジナルのお雛さまをつくることができます。
                                世界でたったひとつのお雛さま。お子さまにとって特別な宝ものとなりますように…。</p>
                        </div>
                        <div class="top-brand__action">
                            <router-link class="top-brand__link" :to="config.path.root + '/step/sizes/1'">はじめる</router-link>
                        </div>
                        <img class="top-brand__cloud-line" src="/choice/img/top/cloud-kagayaki.png" alt="">
                    </div>
                </div>
            </div>
        </v-scroll-animation>
    
        <v-scroll-animation>
            <div class="top-brand__item--right top-brand__item--fuwari">
                <div class="top-brand__wrap">
                    <img class="top-brand__img" src="/choice/img/top/fuwari-img.jpg" alt="">
                    <div class="top-brand__body">
                        <h3 class="top-brand__title">ふわり<small class="top-brand__title-en">fuwari</small></h3>
                        <div class="top-brand__description">
                            <p>『かわいい』を引き出し、現代風にアレンジした新しいコンセプトのお雛さま。お好みのセットにお気に入りのお人形をカスタマイズできるオンリーワンの宝もの</p>
                        </div>
                        <div class="top-brand__action">
                            <router-link class="top-brand__link" :to="config.path.root + '/step/peoples/2?order_1=1&prevPageOrder=1&prevPageSlug=sizes'">はじめる</router-link>
                        </div>
                        <img class="top-brand__cloud-line" src="/choice/img/top/cloud-fuwari.png" alt="">
                    </div>
                </div>
            </div>
        </v-scroll-animation>
        
    </section>
  </div>
</template>

<script>
  export default {
    components: {
      'v-scroll-animation': require('@/components/scroll-animation.vue').default,
    },
  }
</script>



<style lang="scss">
  .top-brand {
    $e: &;
    padding-top: 80px;
    padding-bottom: 64px;
    @include breakpoints-min(md) {
      padding-top: 128px;
      padding-bottom: 96px;
    }
    &__list {
      @include breakpoints-min(md) {
        width: 928px;
        margin-left: auto;
        margin-right: auto;
      }
    }
    &__item {
      position: relative;
      width: 100%;
      &--left {
        @extend #{$e}__item;
        #{$e}__cloud-line {
          right: 40%;
        }
        @include breakpoints-min(md) {
          justify-content: flex-end;
          #{$e}__img {
            float: right;
            margin-right: 52px;
          }
          #{$e}__body {
            right: 564px;
          }
          #{$e}__cloud-line {
            right: -64px;
          }
          @include breakpoints-min(lg) {
            #{$e}__img {
              float: right;
              margin-right: 0;
            }
            #{$e}__body {
              right: 544px;
            }
          }
        }
      }
      &--right {
        @extend #{$e}__item;
        #{$e}__cloud-line {
          left: 40%;
        }
        @include breakpoints-min(md) {
          justify-content: flex-start;
          #{$e}__img {
            float: left;
            margin-left: -60px;
          }
          #{$e}__body {
            left: 452px;
          }
          #{$e}__cloud-line {
            left: -64px;
          }
        }
        @include breakpoints-min(lg) {
          #{$e}__img {
            float: left;
            margin-left: 0;
          }
          #{$e}__body {
            left: 512px;
          }
        }
      }
      &--kagayaki {
        #{$e}__title-en {
          color: $accent-color;
        }
        #{$e}__link {
          background-color: $accent-color;
          @include hover() {
            background-color: $accent-color-hover;
          }
          @include active() {
            background-color: $accent-color-active;
          }
        }
      }
      &--fuwari {
        #{$e}__title-en {
          color: #f5932c;
        }
        #{$e}__link {
          background-color: #f5932c;
          @include hover() {
            background-color: #db7f1d;
          }
          @include active() {
            background-color: #cb7418;
          }
        }
      }
      &--gogatu {
        #{$e}__title-en {
          color: #663610;
        }
        #{$e}__link {
          background-color: #663610;
          @include hover() {
            background-color: #512b0c;
          }
          @include active() {
            background-color: #432309;
          }
        }
      }
    }
    &__wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      overflow: hidden;
      position: relative;
      @include breakpoints-min(md) {
        @include clearfix;
        display: block;
        overflow: visible;
        width: 100%;
      }
    }
    &__img {
      display: block;
      position: relative;
      z-index: 0;
    }
    &__cloud-line {
      display: none;
      position: absolute;
      bottom: -32px;
      width: 480px;
      @include breakpoints-min(md) {
        display: block;
        bottom: -128px;
      }
      @include breakpoints-min(lg) {
        bottom: -160px;
        width: 640px;
      }
    }
    &__body {
      display: flex;
      justify-content: center;
      flex-direction: column;
      font-family: $serif;
      writing-mode: vertical-rl;
      width: 100vw;
      margin-top: 32px;
      @include breakpoints-min(md) {
        display: block;
        position: absolute;
        top: 24px;
        width: auto;
        margin-top: 0;
      }
    }
    &__title {
      font-size: 23px;
      letter-spacing: 0.5em;
      margin-left: 24px;
      @include breakpoints-min(sm) {
        margin-left: 32px;
      }
      @include breakpoints-min(md) {
        margin-left: 24px;
      }
      @include breakpoints-min(lg) {
        margin-left: 32px;
      }
    }
    &__title-en {
      display: block;
      font-family: $sans-serif;
      font-size: 10px;
      letter-spacing: 0.15em;
    }
    &__description {
      font-weight: 300;
      line-height: 2.3;
      letter-spacing: 0.1em;
      height: 288px;
      p {
        text-indent: 1em;
      }
    }
    &__action {
      text-align: right;
      margin-right: 24px;
      @include breakpoints-min(sm) {
        margin-right: 32px;
      }
      @include breakpoints-min(md) {
        margin-right: 24px;
      }
      @include breakpoints-min(lg) {
        margin-right: 32px;
      }
    }
    &__link {
      display: inline-block;
      transition: $transition;
      border-radius: 99px;
      letter-spacing: 0.5em;
      color: #fff;
      margin-bottom: 10px;
      padding: 28px 12px 20px;
      text-decoration: none;
    }

    .scroll-animation {
      $f: '.scroll-animation';
      & + #{$f} {
        margin-top: 64px;
        @include breakpoints-min(md) {
          margin-top: 192px;
        }
      }

      #{$e}__item {
        &--left {
          #{$e}__cloud-line {
            transition: right 3s 0.25s ease-out, opacity 1s 0.75s ease-out;
            right: 96px;
            opacity: 0;
          }
        }
        &--right {
          #{$e}__cloud-line {
            transition: left 3.5s 0.25s ease-out, opacity 1s 0.75s ease-out;
            left: 96px;
            opacity: 0;
          }
        }
      }
      #{$e}__img {
        transition: transform 0.75s ease-out, opacity 0.3s ease-out;
        opacity: 0;
        transform: scale(0.90);
      }
      #{$e}__title,
      #{$e}__description,
      #{$e}__action {
        opacity: 0;
        transform: translateY(-32px);
      }
      #{$e}__title       { transition: 1.5s 0.75s ease-out; }
      #{$e}__description { transition: 1.5s 1.5s ease-out; }
      #{$e}__action      { transition: 1.5s 2.25s ease-out; }
      &.is-visible {
        #{$e}__item {
          &--left {
            #{$e}__cloud-line {
              opacity: 1;
              right: -64px;
            }
          }
          &--right {
            #{$e}__cloud-line {
              opacity: 1;
              left: -64px;
            }
          }
        }
        #{$e}__img {
          transform: scale(1);
          opacity: 1;
        }
        #{$e}__title,
        #{$e}__description,
        #{$e}__action {
          transform: translateY(0);
          opacity: 1;
        }
      }
    }

  }
</style>
